import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  SERVICE_REQUEST_IDENTIFIER,
} from "./constants";

const { TYPES, FIELDS, APPLICATIONS, BAOS, REQUEST_STATE } =
  SERVICE_REQUEST_IDENTIFIER;
export default {
  [LOADER_IDENTIFIER]: false,
  [BAOS]: {
    [LIST_IDENTIFIER]: [],
  },
  [APPLICATIONS]: {
    [LIST_IDENTIFIER]: [],
  },
  [TYPES]: {
    [LIST_IDENTIFIER]: [],
  },
  [FIELDS]: {
    [LIST_IDENTIFIER]: [],
  },
  [REQUEST_STATE]: IResponseState.PENDING,
};
